export const ru = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Добавить текст',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'В корзину',
  ADD_TEMPLATE: 'Добавить шаблон',
  ADJUST_SIZE_KEY: 'Изменить размер',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Выровнять низ',
  ALIGN_CENTER_KEY: 'выровнять центр',
  ALIGN_KEY: 'выравнивать',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'выровнять середину',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Выровнять топ',
  ALL_TAB_TITLE_KEY: 'Все',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',

  BASIC_HELPER_INSTRUCTION1_KEY:
    'Просмотрите содержимое и выберите изображения для вашего дизайна или загрузите собственные',
  BASIC_HELPER_INSTRUCTION2_KEY: 'Просмотрите дизайн или доработайте детали',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Настройте дизайн и добавьте другие элементы к проекту',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'Когда дизайн будет готов, нажмите ДАЛЕЕ, чтобы перейти к последней проверке и оформить заказ.',
  BACK_KEY: 'Назад',
  BACKGROUND_KEY: 'Фон',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'В этой категории не найдено вдохновения',
  BRING_TO_FRONT_KEY: 'На передний план',
  CANCEL_TEXT_KEY: 'Отмена',
  CENTIMETERS_KEY: 'сантиметры',
  CM_KEY: 'см',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Выбрать файл',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Очистить все',
  CLEAR_COLOR_KEY: 'Очистить цвет',
  CLOSE_WINDOW_KEY: 'Закрыть окно',
  CLEAR_ALL_OBJECTS: 'Удалить все объекты',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Это приведет к удалению с фона всех объектов.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Цвет',
  CONTINUE_KEY: 'Продолжить...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© HPDC, L.P., 2013–{0} г.',
  CUSTOM_KEY: 'Особый',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'см',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Макет',
  DELETE_KEY: 'Удалить',
  DOCUMENT_COLORS: 'Цвета документа',
  DONE: 'Done!',
  DONE_KEY: 'Готово',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Загрузить',
  DOWNLOAD_APP_TITLE_KEY: 'Приложение можно загрузить здесь:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Импорт из Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime search',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime images',
  DUPLICATE_KEY: 'Создать копию',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Редактировать оформление',
  EDIT_LOWERCASE_KEY: 'ред-ть',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT: 'Возникла ошибка. Повторите попытку позже.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Вот так незадача! При открытии загруженного файла PDF возникла ошибка.',
  EMAIL_KEY: 'Электронная почта',
  EMAIL_ADDRESS_KEY: 'Адрес электронной почты:',
  EMAIL_CHECKBOX_MESSAGE:
    'Мне известно, что данное лицо понимает, что будет получать сообщения электронной почты от HP от моего имени или от имени поставщика услуг.',
  EXTRA_INFO_KEY: 'Дополнительные сведения',
  EMAIL_NOTIFICATION:
    'Через несколько минут электронное сообщение будет отправлено. Дождитесь окончания обработки информации (не более 15 минут).',
  EMAIL_DIALOG_MESSAGE:
    'Впишите адрес электронной почты человека, с которым вы хотите поделиться своей работой.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Существующая папка',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Перед оформлением заказа убедитесь, что выбрано то, что нужно',
  FINAL_CHECK_TITLE_KEY: 'Последняя проверка',
  FINISH_KEY: 'Готово',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Отразить',
  FOR_KEY: 'за',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Ключевые слова:',
  FOLDER_NAME: 'Имя папки',
  FOLDER_NAME_KEY: 'Имя папки:',
  FOLDER_ALREADY_EXIST_KEY: 'Папка с таким именем уже существует',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Понятно',
  GROUP_ALL_KEY: 'Сгруппировать все',
  GROUP_SCALE: 'Масштаб группы',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Назовите проект',
  HEIGHT_KEY: 'Высота',
  HELP_KEY: 'Справка',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'ИЗОБРАЖЕНИЯ',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Импорт',
  INCHES_COLUMN_HEADER_KEY: 'Дюймы',
  INCHES_KEY: 'дюймов',
  INCHES_UNIT_STRING_KEY: 'дюймы',
  INVALID_EMAIL_ADDRESS_KEY: 'Неверный адрес электронной почты',
  INVALID_INFO_KEY: 'Приведите подробности.',
  INVALID_NAME_KEY: 'Неверное имя',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Размер выбранного файла слишком большой. Максимальный размер файла: 500 Мб.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Вот так незадача! Неверный формат. Поддерживаемые форматы: pdf, jpg, png, svg и tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Язык',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Подробнее',
  LEARN_THE_BASICS_KEY: 'Обучение основам',
  LEGAL_FOOTER_MESSAGE1_KEY: 'Используя данный сайт, вы принимаете эти',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Приложение соответствует',
  LEGAL_FOOTER_MESSAGE3_KEY: 'и',
  LENGTH_STRING_IN_INCHES_KEY: 'дюймы',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Чтобы получить наглядное представление о добавляемом контенте, загрузите приложение LinkReader.',
  LOADING_KEY: 'Загрузка...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Блокировка',
  LOGIN_KEY: 'Вход',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Войти в Dreamstime',
  LOGOUT_KEY: 'Выйти',
  MATERIAL_TITLE_KEY: 'МАТЕРИАЛ',
  MATERIAL_STRING_KEY: 'Материал',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Этот фон не может быть уменьшен в дальнейшем, так как вы достигли минимальной высоты или ширины, необходимой для покрытия вашей стены.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Модель',
  MORE_INFO_TEXT_KEY: 'Подробнее',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Имя:',
  NEXT_BUTTON_TITLE_KEY: 'ДАЛЕЕ',
  NEW_FOLDER_KEY: 'Новая папка:',
  NO_SHADOW_KEY: 'Без теней',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'ОК',
  ORDER_SAMPLE_KEY: 'Заказ образца',
  ORDER_SAMPLE: 'Заказать образец',
  ORDER_SAMPLE_INFOLABEL_1:
    'Выберите фрагмент изображения, образец которого хотите заказать',
  ORDER_SAMPLE_INFOLABEL_2:
    'Вы получите электронное письмо с изображением проекта в реальном масштабе',
  ORDER_SAMPLE_INFOLABEL_3: 'Это поможет оценить его качество и разрешение',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Заказ образца',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Получите сообщение электронной почты с изображением вашего проекта в реальном масштабе, чтобы оценить его качество/разрешение.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Пароль',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Я владею авторскими правами на данное изображение и согласен с',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Пикселы',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'см',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'т. е. что-то важное, что необходимо сообщить в центр печати',
  PLACEHOLDER_INCHES_STRING_KEY: 'дюймы',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Положение',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Сохраните проект',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'В проект внесены изменения. Перед тем как продолжить работу, его проект необходимо сохранить.',
  PRICE_COLUMN_HEADER_KEY: 'Цена',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Обработка...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Предварительный просмотр',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Название проекта',
  PROJECT_NAME: 'Название проекта:',
  PROJECT_ALREADY_EXIST_KEY: 'Проект с таким названием уже существует',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Проект с таким названием уже существует',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Папка с таким именем уже существует',
  PIXELATION_WARNING_KEY: 'Предупреждение о пикселизации',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Из-за разрешения загруженной фотографии ваша кожа может быть искажена или искажена. Чтобы не было размытия, загрузите изображение хорошего качества и избегайте растяжения изображения. Если вас устраивает предварительный просмотр и вы хотите продолжить, продолжайте отправку.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'ОБЯЗАТЕЛЬНО',
  RECOLOR_KEY: 'Изменить цвет',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Изменить цвет',
  REQUEST_SAMPLE_KEY: 'Запросить образец',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Произвольное изменение размера',
  RESIZE_PROPORTIONALLY_KEY: 'Пропорциональное изменение размеров',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Запрос на расценки',
  RIGHT_LOGO_TEXT_KEY: 'от',
  ROTATE_KEY: 'Повернуть',
  ROTATE_LEFT_KEY: 'Повернуть  на угол 90° против часовой стрелки',
  ROTATE_RIGHT_KEY: 'Повернуть  на угол 90° по часовой стрелке',
  ROTATION_KEY: 'Поворот',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Строки и столбцы',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Сохранить',
  SAVING_KEY: 'Сохранение...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Сохранить шаблон',
  SAVE_DIALOG_TITLE: 'Сохраните проект',
  SAVE_PROJECT_NAME_KEY: 'Сначала сохраните проект',
  SAVEDIALOG_MESSAGE:
    'Войдите в систему, чтобы сохранить проект. Если у вас нет учетной записи, мы поможем ее завести. Проделанная работа не будет утеряна.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Вместить изображение в размер вашего макета',
  SCALE_KEY: 'Масштаб',
  SCALE_ALL_KEY: 'Масштабировать все',
  SCALE_TO_FILL_KEY: 'Масштабировать до заполнения',
  SEARCH_BUTTON_TITLE_KEY: 'Поиск',
  SELECT_CUSTOM_SIZE_KEY: 'Выбрать другой размер',
  SELECT_CUSTOM_KEY: 'Особый',
  SEARCH_TITLE: 'Поиск',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Выбрать размер плакатов',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Получить инструкции по установке',
  SEND_TO_BACK_KEY: 'Отправить в исходные',
  SEND_KEY: 'Отправить',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Установить размер',
  SETTINGS_KEY: 'Параметры',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Общая папка',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'кв. фт',
  SQM_UNIT_STRING_KEY: 'кв. м',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Отправить',
  SHARE_LINK_LABEL: 'Выберите тип ссылки, которой хотите поделиться',
  SHARE_EDIT_LINK: 'Редактировать ссылку',
  SHARE_VIEW_LINK: 'Просмотреть ссылку',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT: '* Расстояние просмотра можно изменить в параметрах.',
  TERMS1_KEY: 'условия',
  TERMS2_KEY: 'Положение о конфиденциальности HP',
  TERMS3_KEY: 'Уведомление о праве использования личных данных HP',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Условия использования.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Расположить плиткой',
  TOTAL_KEY: 'ИТОГО',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Спасибо!',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Разблокировать',
  UNGROUP_KEY: 'Разгруппировать',
  UPDATE_TEXT_KEY: 'Обновить',
  UPLOAD_KEY: 'Загрузка изображения',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Имя пользователя',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Отменить расположение плиткой',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Действует',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'НДС',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Просмотреть в Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Просмотреть сведения о дизайне',
  VIEW_DESIGNER_PROFILE_KEY: 'Просмотреть профиль автора',
  VIEW_PRICE_KEY: 'Просмотреть цену',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Настенный плакат',
  WALL_SIZE_TEXT_KEY: 'Размер стены',
  WARNING_KEY: 'Предупреждение.',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Ширина',

  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Ваше имя',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Проект:',
  PROJECT_NAME_ERROR_TEXT: 'Введите название для проекта.',
  PROJECT_FOLDER_ERROR_TEXT: 'Введите имя папки, где хранится проект.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Минимальное расстояние просмотра',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Время сна не найдено',
  NO_ELEMENT_ERROR_MESSAGE: 'Элементы не обнаружены.',
  NO_MORE_IMAGES_FOUND_KEY: 'Больше изображений не найдено',
  NO_PATTERN_ERROR_MESSAGE: 'Узоры не найдены.',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Сообщение:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Текущий масштаб изображения может сказаться на его качестве. Изображение может выглядеть мозаичным при просмотре на расстоянии {0} {1} * (текущее разрешение печати: {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Рекомендованное расстояние для просмотра: {0} {1}. Если это условие невыполнимо, уменьшите масштаб изображения или размер продукта.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Рекомендуемый минимальный размер изображения: {0} x {1} пикс.',
  UPLOAD_STATUS: '{0}% из {1} МБ',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Мин. размеры: {0} (ш) на {1} (в).',
  MINIMUM_HEIGHT_KEY: 'Мин. высота: {0}.',
  MINIMUM_WIDTH_KEY: 'Мин. ширина: {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Максимальные размеры: {0} (ш) на {1} (в).',
  MAXIMUM_WIDTH_KEY: 'Макс. ширина: {0}',
  MAXIMUM_HEIGHT_KEY: 'Макс. высота: {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Введите размеры, используя числа больше нуля.',
  PROCESSING_FAILED: 'Не удалось завершить обработку. Повторите попытку позже',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Многостраничные файлы PDF не поддерживаются.',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'К сожалению, зашифрованные документы PDF не поддерживаются.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Импорт файлов: {0} из {1}',
  RECOLORING_KEY: 'Изменение цвета…',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Однотонный цвет',
  AUTHENTICATE_DIALOG_TITLE: 'Источник содержимого защищен паролем',
  AUTHENTICATE_FAILED_MESSAGE: 'Ошибка авторизации.',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Во время импорта некоторых файлов возникла проблема',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Этот шаблон Inspiration по умолчанию имеет размер {0} X {1} {2}. Размер вашей страницы будет автоматически изменен, чтобы соответствовать этому шаблону.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Выберите ноутбук',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Имя',
  LAST_NAME_KEY: 'Фамилия',
  PHONE_NUMBER_KEY: 'Номер телефона',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Недопустимый номер телефона',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'Принимаю условия и положения',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Подтверждаю свое согласие с тем, что моя личная информация будет передана в компанию HP и будет использоваться для оповещения о будущих рекламных кампаниях HP.*',
  SERVICE_PROVIDER_CONDITION:
    'Подтверждаю свое согласие с тем, что предоставленные мной данные будут переданы поставщикам услуг в целях осуществления процессов печати и доставки.*',
  ORDER_DESIGN: 'Заказать дизайн',
  SUBMIT_YOUR_DESIGN: 'Отправить дизайн',
  SUBMISSION_DESIGN_ORDER: 'Отправка для заказа дизайна',
  ENTER_REQUIRED_FIELDS_KEY: 'Заполните обязательные поля',
  ADDRESS_KEY: 'Адрес',
  INVALID_ADDRESS_KEY: 'Неверный адрес',
  CITY_KEY: 'Город',
  INVALID_CITY_KEY: 'Неверное название города',
  COUNTRY_KEY: 'Страна',
  STATE_KEY: 'Область',
  ZIP_KEY: 'Почтовый индекс',
  INVALID_ZIP_KEY: 'Неверный индекс',
  ORDER_NUMBER: 'Номер заказа',
  YOUR_DETAILS_KEY: 'Ваши данные',
  APPLY_DESIGN_COMPETITION: 'Подать заявку на конкурс дизайнов',
  NOTICE_KEY: 'Примечание:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Для того, чтобы скин ПК был идеально адаптирован к вашему, вы должны выбрать точную модель, соответствующую покупке, как это видно в счете.',
  RESTART_PROJECT_ALERT_TITLE: 'Перезапустить проект?',
  DISCARD_ALERT_MESSAGE: 'Текущий проект будет отменен',
  RESTART: 'Перезапустить',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Размер страницы Внимание!',
  MODIFY_SIZE_WARNING:
    'Если вы хотите изменить размер этого дизайна, вы можете сделать это на вкладке «Настройки». Элементы дизайна могут потребовать редактирования, чтобы приспособиться к желаемым размерам.',
  RANDOMIZE_KEY: 'Randomize',
  MATERIAL_CHOICE_APPLIED: 'Выбор материала применяется.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Блокчейн',
  CERTIFICATE_STRING: 'сертификат',
  AUTHENTICITY_STRING: 'подлинность',
  PLEASE_WAIT: 'Подождите',
  PROTECTING_YOUR_DATA: 'защита данных...',
  SEARCH_YOUR_LAPTOP_KEY: 'Найдите свой ноутбук', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'К сожалению! Мы не смогли найти ноутбуки для вашего поиска.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Серийный номер',
  LOCKED_PROJECT: 'Заблокированный проект',
  LOCKED_MESSAGE:
    'Данный проект заказан, изменить его невозможно. Возможен только его просмотр.',
  EXPIRED_PROJECT: 'Просроченный проект',
  EXPIRED_MESSAGE: 'Срок действия данного проекта истек.',
  DELETED_PROJECT: 'Удаленный проект',
  DELETED_MESSAGE: 'Данный проект удален.',
  CHOOSE_GROUP_TYPE: 'Выберите тип {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Введите числа больше нуля.',
  SIZE_KEY: 'Размер',
  DISTANCE_FROM_KEY: 'Расстояние от',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Мебель',
  FIXTURES_KEY: 'Стенды',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Налево',
  RIGHT_KEY: 'Направо',
  DELETE_WALL_KEY: 'Удалить стену',

  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Выбрать тип холста',
  MAXIMUM_WALL_SIZE_KEY: 'Макс. размер стены: {0} кв.{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'Высота холста превышает высоту стены.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'Ширина холста превышает ширину стены.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Максимальное количество столбцов для заданной ширины: {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Максимальное количество строк для заданной высоты: {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Ширина стены меньше ширины холста.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: '>Мин. ширина стены: {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: 'Мин. высота стены: {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Высота стены меньше высоты холста.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Макс. высота стены: {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Зеркальный',
  NATURAL_KEY: 'Естественный',
  ROWS_KEY: 'Строки',
  COLUMNS_KEY: 'Столбцы',
  DEFAULT_WALL_SIZE_KEY: 'Размер стены по умолчанию',
  EDIT_KEY: 'Изменить',
  TOP_KEY: 'Наверх',
  BOTTOM_KEY: 'Вниз'
};
